import { RuxIndeterminateProgress } from '@astrouxds/react';

export const Loading: React.FC = () => (
  <div className='flex-center'>
    <RuxIndeterminateProgress />
  </div>
);
